<header class="header">
  @if (logo()) {
    <div class="header__logo">
      <img [src]="logo()!" [alt]="'shared.header.logoAlt' | translate" class="header__logo-icon" />
    </div>
  }
</header>
